import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';

/**
 * Custom hook to periodically check if the user is still authenticated
 * and redirect to login page if not
 * 
 * @param {number} interval - Check interval in milliseconds (default: 5000ms)
 */
const useAuthCheck = (interval = 5000) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check authentication immediately on component mount
    if (!authService.isAuthenticated()) {
      navigate('/login', { replace: true });
      return;
    }

    // Set up periodic check
    const checkAuth = () => {
      if (!authService.isAuthenticated()) {
        navigate('/login', { replace: true });
      }
    };

    const intervalId = setInterval(checkAuth, interval);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [navigate, interval]);
};

export default useAuthCheck;
